import { ACCESS_GROUPS } from '../../../auth/roles';

import React from 'react';
import {
  MdDashboard,
  MdGroup,
  MdGroupAdd,
  MdDomainAdd,
  MdSchedule,
  MdAllInclusive,
  MdCalculate,
  MdExitToApp,
  MdAssignmentAdd,
  MdCurrencyExchange,
  MdOutlineCurrencyExchange,
  MdFactory,
  MdScale,
  MdOutlineWifiProtectedSetup,
} from 'react-icons/md';
import { FaBuilding } from "react-icons/fa";
import { GiFoodChain, GiFruitBowl } from "react-icons/gi";
import { TbRulerMeasure } from "react-icons/tb";
import { FaScaleBalanced, FaUserDoctor } from "react-icons/fa6";
import { BiFoodMenu } from 'react-icons/bi';

const AccessControl0 = ["Developer"];
const AccessControl1 = ["Developer", "Admin"];
const AccessControl2 = ["Developer", "Admin", "Manager"];
const AccessControl3 = ["Developer", "Admin", "Manager", "Coordinator"];
const AccessControl4 = ["Developer", "Admin", "Manager", "Coordinator", "User"];

export const linksConfig = [
  {//Dropdown
    type: 'link',
    label: 'Dashboard',
    icon: <MdDashboard className='icon' />,
    navigateTo: '/home/dashboard',
    requiredRoles: AccessControl4
  },
  {//Agendamentos
    type: 'dropdown',
    label: 'Agendamentos',
    icon: <MdSchedule className='icon' />,
    subItems: [
      {
        label: 'Todos os Agendamentos',
        icon: <FaBuilding className='icon' />,
        navigateTo: '/home/appointment/get',
        requiredRoles: AccessControl4
      },
      {
        label: 'Novo Agendamento',
        icon: <MdDomainAdd className='icon' />,
        navigateTo: '/home/appointment/create',
        requiredRoles: AccessControl4
      }
    ],
    requiredRoles: AccessControl4
  },
  {//Alimentos
    type: 'dropdown',
    label: 'Alimentos',
    icon: <GiFruitBowl className='icon' />,
    subItems: [
      {
        label: 'Todos os Alimentos Taco4',
        icon: <GiFruitBowl className='icon' />,
        navigateTo: '/home/nutridata/get/taco4foods',
        requiredRoles: AccessControl4
      },
      // {
      //   label: 'Todos os Alimentos',
      //   icon: <GiFruitBowl className='icon' />,
      //   navigateTo: '/home/nutridata/get/atfd',
      //   requiredRoles: AccessControl4
      // },
      {
        label: 'Novo Alimento',
        icon: <GiFruitBowl className='icon' />,
        // navigateTo: '/home/nutridata/create',
        navigateTo: '/home/custom_food/create',
        requiredRoles: AccessControl3
      },

      // {
      //   label: 'Alimento Dinâmico',
      //   icon: <GiFruitBowl className='icon' />,
      //   navigateTo: '/home/nutridata/get/dynamic',
      //   requiredRoles: ['Admin', 'Manager', 'Coordinator']
      // }
    ],
    requiredRoles: AccessControl4
  },
  {//Antropometria
    type: 'dropdown',
    label: 'Antropometria',
    icon: <TbRulerMeasure className='icon' />,
    subItems: [
      {
        label: 'Todas Antropometrias',
        icon: <TbRulerMeasure className='icon' />,
        navigateTo: '/home/anthropometry/get/withFilters',
        requiredRoles: AccessControl3
      },
      {
        label: 'Nova Antropometria',
        icon: <TbRulerMeasure className='icon' />,
        navigateTo: '/home/anthropometry/create',
        requiredRoles: AccessControl3
      },
      {
        label: 'Por Paciente',
        icon: <TbRulerMeasure className='icon' />,
        navigateTo: '/home/anthropometry/get',
        requiredRoles: AccessControl3
      },
    ],
    requiredRoles: AccessControl3
  },
  {//Consultas
    type: 'dropdown',
    label: 'Consultas',
    icon: <FaUserDoctor className='icon' />,
    subItems: [
      {
        label: 'Todas as Consultas',
        icon: <FaUserDoctor className='icon' />,
        navigateTo: '/home/consultation/get',
        requiredRoles: AccessControl4
      },
      {
        label: 'Nova Consulta',
        icon: <FaUserDoctor className='icon' />,
        navigateTo: '/home/appointment/get',
        requiredRoles: AccessControl2
      },
      {
        label: 'Por Paciente',
        icon: <FaUserDoctor className='icon' />,
        navigateTo: '/home/consultation/get/byPatient',
        requiredRoles: AccessControl2
      }
    ],
    requiredRoles: AccessControl4
  },
  {//Convênios
    type: 'dropdown',
    label: 'Convênios',
    icon: <MdAllInclusive className='icon' />,
    subItems: [
      {
        label: 'Todos os convênios',
        icon: <MdAssignmentAdd className='icon' />,
        navigateTo: '/home/dashboard',
        requiredRoles: AccessControl1
      },
      {
        label: 'Novo convênio',
        icon: <MdAssignmentAdd className='icon' />,
        navigateTo: '/home/dashboard',
        requiredRoles: AccessControl1
      }
    ],
    // requiredRoles: AccessControl1
    requiredRoles: AccessControl0
  },
  {//Dietas
    type: 'dropdown',
    label: 'Dietas',
    icon: <MdScale className='icon' />,
    subItems: [
      {
        label: 'Nova Dieta',
        icon: <MdScale className='icon' />,
        navigateTo: '/home/diet/create',
        requiredRoles: AccessControl3
      },
      {
        label: 'Por Paciente',
        icon: <MdScale className='icon' />,
        navigateTo: '/home/diet/get',
        requiredRoles: AccessControl3
      },
    ],
    requiredRoles: AccessControl3
  },
  {//Empresas
    type: 'dropdown',
    label: 'Empresas',
    icon: <MdFactory className='icon' />,
    subItems: [
      {
        label: 'Todas as Empresas',
        icon: <FaBuilding className='icon' />,
        navigateTo: '/home/company/get',
        requiredRoles: AccessControl4
      },
      {
        label: 'Nova Empresa',
        icon: <MdDomainAdd className='icon' />,
        navigateTo: '/home/company/create',
        requiredRoles: AccessControl3
      }
    ],
    requiredRoles: AccessControl4
  },
  {//Financeiro
    type: 'dropdown',
    label: 'Financeiro',
    icon: <MdCalculate className='icon' />,
    subItems: [
      {
        label: 'Contas a pagar',
        icon: <MdCurrencyExchange className='icon' />,
        navigateTo: '/home/dashboard',
        requiredRoles: AccessControl1
      },
      {
        label: 'Contas a receber',
        icon: <MdOutlineCurrencyExchange className='icon' />,
        navigateTo: '/home/dashboard',
        requiredRoles: AccessControl1
      }
    ],
    requiredRoles: AccessControl0
  },
  {//Nutricionista
    type: 'dropdown',
    label: 'Nutricionistas',
    icon: <FaUserDoctor className='icon' />,
    subItems: [
      {
        label: 'Todos os Nutricionistas',
        icon: <FaUserDoctor className='icon' />,
        navigateTo: '/home/nutritionist/get',
        requiredRoles: AccessControl4
      },
      {
        label: 'Novo Nutricionista',
        icon: <FaUserDoctor className='icon' />,
        navigateTo: '/home/nutritionist/create',
        requiredRoles: AccessControl3
      }
    ],
    requiredRoles: AccessControl4
  },
  {//Pacientes
    type: 'dropdown',
    label: 'Pacientes',
    icon: <MdGroup className='icon' />,
    subItems: [
      {
        label: 'Todos os pacientes',
        icon: <MdGroup className='icon' />,
        navigateTo: '/home/patient/get',
        requiredRoles: AccessControl4
      },
      {
        label: 'Novo paciente',
        icon: <MdGroupAdd className='icon' />,
        navigateTo: '/home/patient/create',
        requiredRoles: AccessControl3
      }
    ],
    requiredRoles: AccessControl4
  },
  // {//Pessoas
  //   type: 'dropdown',
  //   label: 'Pessoas',
  //   icon: <MdGroup className='icon' />,
  //   subItems: [
  //     {
  //       label: 'Todas as Pessoas',
  //       icon: <MdGroup className='icon' />,
  //       navigateTo: '/home/person/get',
  //       requiredRoles: AccessControl4
  //     },
  //     {
  //       label: 'Nova pessoa',
  //       icon: <MdGroupAdd className='icon' />,
  //       navigateTo: '/home/person/create',
  //       requiredRoles: AccessControl3
  //     },
  //     {
  //       label: 'Lista todas Pessoas',
  //       icon: <MdGroup className='icon' />,
  //       navigateTo: '/home/person/get/list',
  //       requiredRoles: AccessControl1
  //     },
  //   ],
  //   requiredRoles: AccessControl4
  // },
  {//Usuários
    type: 'dropdown',
    label: 'Usuários',
    icon: <MdGroup className='icon' />,
    subItems: [
      {
        label: 'Todos os usuários',
        icon: <MdGroup className='icon' />,
        navigateTo: '/home/user/get',
        requiredRoles: AccessControl1
      },
      {
        label: 'Novo usuário',
        icon: <MdGroupAdd className='icon' />,
        navigateTo: '/home/user/create',
        requiredRoles: AccessControl1
      }
    ],
    requiredRoles: AccessControl1
  },
  {//Configurações
    type: 'dropdown',
    label: 'Configurações',
    icon: <MdOutlineWifiProtectedSetup className='icon' />,
    subItems: [
      {
        label: 'Tipos de Consulta',
        icon: <MdOutlineWifiProtectedSetup className='icon' />,
        navigateTo: '/home/setup/consultation_types/get',
        requiredRoles: AccessControl1
      },
      {
        label: 'Unidades de Medidas',
        icon: <MdOutlineWifiProtectedSetup className='icon' />,
        navigateTo: '/home/setup/unity_measurements/get',
        requiredRoles: AccessControl1
      }
    ],
    requiredRoles: AccessControl1
  },
  {//Sair
    type: 'link',
    label: 'Sair',
    icon: <MdExitToApp className='icon' />,
    action: 'logout',
    requiredRoles: AccessControl4
  }
];
